import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { datetimeFormat } from 'app/constants/date-time-format';
import { CalculationService, DataService, DateService, HelperService, HTTPService } from 'app/services';
import { currency } from 'app/constants/currency.constants';
import { find } from 'lodash';

@Component({
  selector: 'app-authorization-core-parts',
  templateUrl: './authorization-core-parts.component.html',
  styleUrls: ['./authorization-core-parts.component.scss'],
  providers: [DialogService],
})
export class AuthorizationCorePartsComponent implements OnInit {
  //@Input() order: any = {};

  //@Output() appIsCorePartsVisible = new EventEmitter();

  coreStatusOptions: any[] = [
    { name: 'Core: To be retrieved', value: 'toBeRetrieved' },
    { name: 'Core: Retrieved', value: 'retrieved' },
    { name: 'Core: Damaged', value: 'damaged' },
  ];
  //itemsWithCore: any[] = [];
  @Input() orderWithCoreItems: any = {
    oderId: '',
    itemsWithCore: []
  };
  constructor(private httpService: HTTPService, private helperService: HelperService, public dataService: DataService) {}

  ngOnInit() {
    // this.order.services?.forEach(({ title, items = [] }) => {
    //   items?.forEach((item: any) => {
    //     if (item?.hasCore && !['retrieved', 'damaged'].includes(item.coreRetrievalStatus)) {
    //       item.serviceTitle = title;
    //       item._coreRetrievalStatus = find(this.coreStatusOptions, { value: item.coreRetrievalStatus || 'toBeRetrieved' });
    //       this.itemsWithCore.push(item);
    //     }
    //   });
    // });

    // this.appIsCorePartsVisible.emit(!!this.itemsWithCore.length);
  }

  selectCoreStatus(item: any, retrievalStatus: string) {
    const data = {
      retrievalStatus: retrievalStatus,
      //orderId: this.order._id,
      orderId: this.orderWithCoreItems.orderId,
      orderItemId: item.orderItemId,
      itemInternalReference: item.itemInternalReference,
      itemSource: item.itemSource,
    };
    this.httpService.updateCoreItemStatus('', data).then(
      (res: any) => {
        item.coreRetrievalStatus = retrievalStatus;
        this.helperService.showToaster('success', 'Successfully updated');
      },
      (error) => {
        this.helperService.showToaster('error', error);
      }
    );
  }
}
